import Grid from '@mui/material/Grid';
import React, { useEffect, useState } from 'react';
import CommitApi from '../../api/commitApi';
import CommitHistoryTable from './components/CommitHistoryTable';
import SchemaSelectContainer from './containers/SchemaSelectContainer';
import { useSelectedSchema } from '../../hooks/useSelectedSchema';
import { CommitModel } from '../../models/commitModel';
import { AppErrorList, useAppErrorList } from '../../shared/components/AppErrorList';
import SingleSelect from '../../shared/components/SingleSelect';

const COMMIT_HISTORY_DEPTH_OPTIONS = [
  { id: '5depth', label: '5', numVal: 5 },
  { id: '10depth', label: '10', numVal: 10 },
  { id: '15depth', label: '15', numVal: 15 },
];

const DEFAULT_COMMIT_HISTORY_DEPTH = 5;
const DEFAULT_COMMIT_HISTORY_DEPTH_ID = '5depth';

const ConfigsHistoryView = () => {
  const [selectedSchema] = useSelectedSchema();

  const [depth, setDepth] = useState<number>(DEFAULT_COMMIT_HISTORY_DEPTH);

  const [commitHistory, setCommitHistory] = useState<CommitModel[]>([]);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [{ errors, hasErrors }, { addError }] = useAppErrorList();

  const commitId = selectedSchema?.headCommitId;

  useEffect(() => {
    if (commitId) {
      setLoading(true);

      CommitApi.fetchCommitHistory(commitId, depth)
        .then(setCommitHistory)
        .catch(addError)
        .finally(() => setLoading(false));
    } else {
      setCommitHistory([]);
    }
  }, [addError, commitId, depth]);

  return (
    <Grid container spacing={2}>
      { hasErrors && (
        <Grid item md={12}>
          <AppErrorList errors={errors} />
        </Grid>
      )}

      <Grid item md={3} xs={12}>
        <SchemaSelectContainer />
      </Grid>
      <Grid item md={1} xs={12}>
        <SingleSelect
          label='Max depth'
          options={COMMIT_HISTORY_DEPTH_OPTIONS}
          defaultOptionId={DEFAULT_COMMIT_HISTORY_DEPTH_ID}
          onSelect={depth => setDepth(depth.numVal)}
        />
      </Grid>

      <Grid item xs={12}>
        <CommitHistoryTable
          commitHistory={commitHistory}
          isLoading={isLoading}
        />
      </Grid>
    </Grid>
  );
};

export default ConfigsHistoryView;
